import script from "./TeachingListSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TeachingListSection.vue?vue&type=script&setup=true&lang=js"

import "./TeachingListSection.vue?vue&type=style&index=0&id=68748a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68748a16"]])

export default __exports__